import api from "../_app/api";
import { parsePermissions } from "../permission/api";
import { GetRolesResponse, Role } from "./types";

export const getAllRoles = async (accountId: string, page?: number, limit?: number) => {
  const { data }: { data: GetRolesResponse } = await api({
    method: "GET",
    url: "/roles",
    params: {
      page,
      size: limit,
      "account-id": accountId,
    },
  });
  data.list?.forEach((role) => role?.permissions?.map(parsePermissions));
  return data;
};

export const getRoleById = async (accountId: string, roleId: string) => {
  const { data }: { data: Role } = await api({
    method: "GET",
    url: "/roles/" + roleId,
    params: { "account-id": accountId },
  });
  data.permissions = data?.permissions?.map(parsePermissions);
  return data;
};

export const updateRole = async (accountId: string, role: Role) => {
  const { data }: { data: Role } = await api({
    method: "PUT",
    url: `/roles/${role?.id}`,
    params: { "account-id": accountId },
    data: role,
  });
  return data;
};

export const createRole = async (accountId: string, role: Role) => {
  const { data }: { data: Role } = await api({
    method: "POST",
    url: "/roles",
    params: { "account-id": accountId },
    data: { ...role },
  });
  return data;
};

export const deleteRole = async (accountId: string, role: Role) => {
  const { data }: { data: Role } = await api({
    method: "DELETE",
    url: `/roles/${role?.id}`,
    params: { "account-id": accountId },
  });
  return data;
};
